import React, {Suspense, lazy} from 'react';
import {
  ROUTE_DR_POTENTIAL_DETAIL_REPORT,
} from '@app/navigations/RoutePathConstant';
import {authLoader} from '@app/navigations/loader';
import {Spin} from 'antd';

const DrPotentialDetailReport = lazy(() =>
  import('../../../screens/DrPotentialDetailReport')
    .then(module => ({default: module.DrPotentialDetailReport})));

const DrPotentialDetailReportNavigation = [
  {
    path: ROUTE_DR_POTENTIAL_DETAIL_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <DrPotentialDetailReport />
      </Suspense>
    ),
  },
];

export default DrPotentialDetailReportNavigation;
